<template>
  <div class="common-step">
    <!-- 标题 -->
    <h2 class="step-title">{{ title }}</h2>

    <!-- 步骤条 -->
    <div class="step-container">
      <div
          v-for="(step, index) in steps"
          :key="index"
          class="step-item"
          :class="{ 'is-last': index === steps.length - 1 }"
      >
        <!-- 步骤图标和数字 -->
        <div class="step-icon-container">
          <!-- 已完成步骤 -->
          <div v-if="index < currentStepIndex" class="step-icon completed">
            <img src="@/assets/common/icon_check_circle_filled.png" width="36" height="36">
          </div>

          <!-- 当前步骤 -->
          <div v-else-if="index === currentStepIndex" class="step-icon current">
            {{ index + 1 }}
          </div>

          <!-- 未完成步骤 -->
          <div v-else class="step-icon pending">
            {{ index + 1 }}
          </div>
        </div>

        <!-- 步骤标题 -->
        <div class="step-label" :class="getStepLabelClass(index)">
          {{ step }}
        </div>

        <!-- 连接线 -->
        <div
            v-if="index < steps.length - 1"
            class="step-connector"
            :class="getConnectorClass(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonStep',
  props: {
    title: {
      type: String,
      required: true
    },
    steps: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.length > 0 && value.every(step => typeof step === 'string')
      }
    },
    currentStepIndex: {
      type: Number,
      default: 0,
      validator: function (value) {
        return value >= 0
      }
    }
  },
  methods: {
    getStepLabelClass(index) {
      if (index < this.currentStepIndex) {
        return 'completed-label';
      } else if (index === this.currentStepIndex) {
        return 'current-label';
      } else {
        return 'pending-label';
      }
    },
    getConnectorClass(index) {
      if (index < this.currentStepIndex) {
        return 'completed';
      } else {
        return 'pending';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.common-step {
  display: flex;
  flex-direction: column;
  gap: 60px;
  width: 100%;
}

.step-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.33em;
  color: #333333;
  margin: 0;
  text-align: left;
}

.step-container {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;

  .step-connector {
    width: 50px;
    height: 1px;

  }

  .completed {
    background-color: #D8000F;
  }

  .pending {
    background-color: #ECEEF0;
  }
}

.step-item {
  display: flex;
  gap: 16px;
  position: relative;
  align-items: center;
}

.step-icon-container {
  position: relative;
  width: 36px;
  height: 36px;

  .completed {
    background-color: #D8000F;
    color: white;
    border-radius: 20px;
  }


  .current {
    background-color: #D8000F;
    color: white;
    border-radius: 20px;
  }


  .pending {
    background-color: #ECEEF0;
    border-radius: 20px;
  }

}

.step-icon {
  width: 36px;
  height: 36px;
  line-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.step-label {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  white-space: nowrap;

}
.completed-label {
  color: #333333;
}

.current-label {
  color: #D8000F;
}
.pending-label {
  color: #333333;
}

</style>
